import React from 'react';
import { Box, Typography } from '@mui/material';
import { Helmet } from 'react-helmet';
import { Button } from '@mui/material';

const StorePage = () => {
  return (
    <Box sx={{ backgroundColor: '#283593', minHeight: '100vh', color: '#fff', display: 'flex', justifyContent: 'center', alignItems: 'center', flexDirection: 'column', textAlign: 'center', padding: '20px' }}>
      <Helmet>
        <title>Satoshi Advance | Store Coming Soon</title>
        <meta name="description" content="Satoshi Advance merchandise store coming soon." />
      </Helmet>
      <Typography variant="h3" sx={{ fontFamily: '"Press Start 2P", cursive', marginBottom: '20px' }}>
        Store Coming Soon
      </Typography>
      <Typography variant="body1" sx={{ maxWidth: '600px' }}>
        Our Bitcoin & Crypto branded merchandise store is under construction. Check back later for awesome swag!
      </Typography>
      <Button
        onClick={() => window.location.href = '/'}
        sx={{
          fontFamily: "'Press Start 2P', cursive",
          fontSize: '1rem',
          color: '#FFFFFF',
          backgroundColor: 'transparent',
          border: '2px solid #FFFFFF',
          borderRadius: '4px',
          padding: '10px 20px',
          marginTop: '30px',
          textTransform: 'uppercase',
          '&:hover': {
            backgroundColor: 'rgba(255, 255, 255, 0.1)',
            boxShadow: '0 0 10px #00BFFF'
          },
          transition: 'all 0.3s ease'
        }}
      >
        Home
      </Button>

    </Box>
  );
};

export default StorePage;
